import { PropsWithChildren, useEffect, useRef } from 'react'

import { useVersionInfo } from '@/feature/version'

import styles from './VersionChecker.module.css'

export const VersionChecker = ({ children }: PropsWithChildren) => {
  const buildId = process.env.NEXT_PUBLIC_BUILD_ID

  const ref = useRef<HTMLDialogElement>(null)

  const remoteVersion = useVersionInfo({
    refreshInterval: 1000 * 60 * 60,
  })

  useEffect(() => {
    if (remoteVersion.latest) {
      ref.current?.close()
    } else {
      ref.current?.showModal()
      ref.current?.style.setProperty('--sun-offset-x', '120%')
      ref.current?.style.setProperty('--sun-offset-y', '90%')
      ref.current?.style.setProperty('--burn-off', '0')

      setTimeout(() => {
        window.location.reload()
      }, 9000)
    }
  }, [remoteVersion.latest, ref.current])

  return remoteVersion.latest ? (
    children
  ) : (
    <dialog className={styles.versionDialog} ref={ref}>
      <header>System has updated</header>
      <main>
        <p>The system has been updated to a new version.</p>
        <p>The page will refresh automatically, please be patient</p>
      </main>
      <footer>
        <p>
          If you keep seeing this message try to refresh manually
          <br />
          or get in contact with the text below
          <br />
          <span className={styles.buildId}>{buildId}</span>
        </p>
      </footer>
    </dialog>
  )
}
